// Function to check if test is currently accessible
export const isTestAccessible = (test) => {
  if (!test?.startDateTime || !test?.endDateTime) {
    return true;
  }

  const now = new Date();
  const startDate = new Date(test.startDateTime);
  const endDate = new Date(test.endDateTime);

  return now >= startDate && now <= endDate;
};

// Function to create array from ID
export const createArrayFromId = (id) => {
  return [id];
};

// Function to render test button based on user role
export const renderTestButton = (
  test,
  topic,
  testInd,
  roleOfTheUser,
  StartButton,
  Button,
  setSelectedTopicId,
  setSelectedTest,
  setOpen,
  classroomId,
  hasValidSubscription,
  activeTab
) => {
  return roleOfTheUser === "Student" ? (
    <StartButton
      onClick={() => {
        setSelectedTopicId(topic?._id);
        setSelectedTest(test);
        setOpen(true);
      }}
      classRoomId={classroomId}
      requiredFeature="Topic-wise Tests"
      hasValidSubscription={hasValidSubscription}
      subjects={createArrayFromId(activeTab)}
      index={testInd}
    >
      Start
    </StartButton>
  ) : (
    <Button
      onClick={() => {
        setSelectedTopicId(topic?._id);
        setSelectedTest(test);
        setOpen(true);
      }}
      className="start-classroom-styles"
      variant="outline-primary"
    >
      Start
    </Button>
  );
}; 